export enum ForcedMaintenanceEnum  {
    ON,
    OFF,
    NOT_SET
}
